import React from 'react';
import axios from 'axios';

import auth from '../utils/auth';

import Loading from '../components/Loading.jsx';
import Pagination from '../components/Pagination.jsx';
import OrdersTable from '../components/OrdersTable.jsx';
import { useUser } from './User';
import { useParams, useSearchParams } from 'react-router-dom';

const getOrders = async (userId, start = 0, query = {}) => {
    try {
        let { data } = await axios.request({
            url: `/orders/search`,
            method: 'GET',
            params: {
                start: start,
                page_size: 20,
                sort: 'submitted_date:desc',
                ...query
            },
            headers: {
                'Content-Type': 'application/json',
                'Customer-Id': userId,
                'Session-Key': auth.getSID()
            }
        });
        return data;
    } catch (error) {
        throw error;
    }
};

const UserOrders = () => {
    const params = useParams();
    const [queryParams] = useSearchParams();
    const start = queryParams.get('start') || 0;
    const { user } = useUser(params.user_id);
    const [inProgress, setInProgress] = React.useState(true);
    const [orders, setOrders] = React.useState([]);
    const [hits, setHits] = React.useState(0);

    React.useEffect(() => {
        const load = async () => {
            setInProgress(true);

            let orders = await getOrders(params.user_id, start, {
                org: user?.netsuite_entity,
                customer: params.user_id
            });
            setInProgress(false);
            setOrders(orders.data);
            setHits(orders.hits);
        };
        if (user.netsuite_entity) {
            load();
        }
    }, [start, params.user_id, user.netsuite_entity]);

    return (
        <div>
            <h2>Order History</h2>
            <hr />

            {inProgress && <Loading />}

            {!inProgress && <OrdersTable orders={orders} />}

            <Pagination
                pathName={`/customer/${user._id}/orders`}
                totalResults={hits}
                perPage={20}
                currentPage={Number(start)}
            />
        </div>
    );
};
export default UserOrders;
